import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import colorsJsonGreen from './../../../../assets/teiasoft-themes/green.json';
import colorsJsonBlue from './../../../../assets/teiasoft-themes/blue.json';
import colorsJsonSilver from './../../../../assets/teiasoft-themes/silver.json';

@Component({
  selector: 'teiasoft-title',
  templateUrl: './teiasoft-title.component.html',
  styleUrls: ['./teiasoft-title.component.scss']
})
export class TeiasoftTitleComponent implements OnInit {
  @Input() title: string = "TITLE";
  @Input() theme?: string = "silver";
  @Input() isMobile:boolean = false;
  @Input() size: string = 'big';
  
  constructor(private router: Router){
  }

  ngOnInit(): void {
    //this.title = this.translate.istant('pageTitles-' + this.router.url.replace("/", ""));
  }

}
